/**
 * 外部リンクなどのURLを定数管理する
 */

/**
 * 視聴方法
 */
export const URL_WATCH_HOWTO = 'https://www.tbs.co.jp/tbs-ch/about/';

/**
 * TBSチャンネルについて
 */
export const URL_ABOUT_US = 'https://www.tbs.co.jp/tbs-ch/about/aboutus.html';

/**
 * 個人情報保護方針
 */
export const URL_PRIVACY_POLICY = 'https://www.tbsholdings.co.jp/tbstv/privacy/policy.html';

/**
 * プレゼント
 */
export const URL_PRESENT_PAGE = 'https://www.tbs.co.jp/tbs-ch/present/';

/**
 * お問い合わせ
 * NOTE: S3からjsonで取得する
 */
